import { useTranslation } from "react-i18next";
import { Drawer } from "antd";
import PropTypes from "prop-types";
import {
  renderDefaultOptions,
  renderEntradasOptions,
  renderRespuestasOptions,
} from "./components";

import "./Sidebar.scss";
import { useSidebar } from "./context";
import { useSidebarActions } from "./hook/actionButtons";

const SidebarFlow = ({
  hasDescripcion,
  hasRespuestas,
  hasExtensions,
  hasParams,
  hasDefaultResponse,
}) => {
  const { t } = useTranslation();
  const { sidebar, closeSidebar } = useSidebar();

  const isFromEntradas = sidebar?.originType === "entryNode";
  const isFromRespuestas =
    sidebar?.originType === "responseNode" &&
    sidebar?.type === "context_output";

  const handleAdd = (type) => {
    if (sidebar?.data?.onAddNodeCallback) {
      sidebar.data.onAddNodeCallback({ id: sidebar.id, type });
      closeSidebar();
    }
  };

  const actionButtons = useSidebarActions(t, {
    hasDescripcion,
    hasParams,
    hasRespuestas,
    hasExtensions,
    hasDefaultResponse,
  });

  return (
    <Drawer
      open={sidebar.open}
      onClose={closeSidebar}
      placement="right"
      className="sidebar-container"
      width={360}
      style={{
        padding: "0px",
      }}
    >
      <span className="sidebar-title">
        {t("common:intents.flow_chat.title")}
      </span>
      <p className="sidebar-subtitle">
        {t("common:intents.flow_chat.message")}
      </p>

      {isFromRespuestas
        ? renderRespuestasOptions(handleAdd, t)
        : isFromEntradas
        ? renderEntradasOptions(handleAdd, t)
        : renderDefaultOptions(handleAdd, actionButtons)}
    </Drawer>
  );
};
SidebarFlow.propTypes = {
  hasDescripcion: PropTypes.bool,
  hasRespuestas: PropTypes.bool,
  hasExtensions: PropTypes.bool,
  hasParams: PropTypes.bool,
  hasDefaultResponse: PropTypes.bool,
};
export default SidebarFlow;
